import { Injectable } from '@angular/core';
var LyCheckboxService = (function () {
    function LyCheckboxService() {
    }
    return LyCheckboxService;
}());
export { LyCheckboxService };
LyCheckboxService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LyCheckboxService.ctorParameters = function () { return []; };
function LyCheckboxService_tsickle_Closure_declarations() {
    /** @type {?} */
    LyCheckboxService.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyCheckboxService.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/checkbox/ly-checkbox.service.js
// module id = 691
// module chunks = 31